// Shared key derivation for the back-save / back-restore controller pair.
//
// The key defaults to the first path segment ("accounts" for /accounts?page=2
// as well as for /accounts/1), which is what you want for a REST resource.
// Set `data-back-save-key-value` / `data-back-restore-key-value` when a detail
// page lives under a different path than its list.
export function backStorageKey(controller) {
  const key =
    controller.keyValue || window.location.pathname.split("/")[1] || "root"

  return `back:${key}`
}
